import { gql } from '@grandvisionhq/graphql';
import { getReturnFailuresFragment } from '../fragments/get-return-failures.js';
import { returnFragment } from '../fragments/return.js';

const GET_RETURN = gql`
  query GetReturn($input: GetReturnInput!) {
    getReturn(input: $input) {
      return {
        ...ReturnFragment
      }
      failures {
        ...GetReturnFailuresFragment
      }
    }
  }
  ${returnFragment}
  ${getReturnFailuresFragment}
`;

export { GET_RETURN };
//# sourceMappingURL=get-return.js.map
